import { useEffect, useState } from "react";
import { AdminMainWrapper } from "../mini-components/admin-main-wrapper";
import { useNavigate } from "react-router-dom";
import { url } from "../../weburl";
import axios from "axios";

export const AdminAllUsers = () => {
  const dummyData = [
    { id: "1", username: "Donnie", email: "email@email.com" },
    { id: "2", username: "Connie", email: "dmail@email.com" },
    { id: "3", username: "Fonnie", email: "fmail@email.com" },
    { id: "4", username: "Gonnie", email: "gmail@email.com" },
    { id: "5", username: "Honnie", email: "hmail@email.com" },
  ];
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);

  const getUsers = () => {
    axios
      .get(`${url}api/users`)
      .then((res) => setUsers(res.data))
      .then((data) => console.log(data))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getUsers();
  }, []);

  return (
    <AdminMainWrapper>
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th scope="col">#id</th>
            <th scope="col">Username</th>
            <th scope="col">Email</th>
          </tr>
        </thead>
        <tbody>
          {users.map(({ id, username, email }) => {
            return (
              <tr
                style={{ cursor: "pointer" }}
                onClick={() => navigate(`/admin/user/${id}`)}
              >
                <th scope="row">{id}</th>
                <td>{username}</td>
                <td>{email}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </AdminMainWrapper>
  );
};
